var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar",staticStyle:{"overflow":"overlay"},style:({ height: _vm.height })},[_c('menucpn',{attrs:{"sidebarData":_vm.menuData},on:{"update:sidebarData":function($event){_vm.menuData=$event},"update:sidebar-data":function($event){_vm.menuData=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }